export default ({axios}) => ({
    login: (body = {}) => axios.post(`/login`, body),
    logout: () => axios.post('/logout'),
    refreshJwt: () => axios.post('/refresh-jwt'),
    confirmAccount: () => axios.post('/confirm-account'),
    sendPasswordReset: (email) => axios.post(`/send-password-reset/${email}?_app=admin`),
    confirmPasswordReset: (body) => axios.post('/confirm-password-reset', body)
})
